<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/producttype')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-overlay absolute :value="this.loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <v-card-title tabindex="-1">
        <span class="headline">Create Product Type</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['ProductType/fetchProductTypes']({ page: this.page });
              $router.push('/producttype');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="createForm">
          <v-text-field
            :rules="validationRules.name"
            v-model="createFields.name"
            label="Product Type *"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveProductType"
            tabindex="1"
          />
        </v-form>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/producttype');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveProductType">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      continousCreation: false,
      validationRules: {
        name: [
          v => !!v || this.rem('ProductType name'),
          v => v.length <= 255 || 'ProductType name should not be greater than 255'
        ]
      },
      errorMessages: {},
      createFields: {
        name: ''
      }
    };
  },
  computed: {
    ...mapState({})
  },
  mounted() {},
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes']),
    clearCreate() {
      this.createFields = {
        name: ''
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveProductType() {
      if (this.$refs.createForm.validate()) {
        this.loading = true;
        axios
          .post('api/v1/type', this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product Type created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['ProductType/fetchProductTypes']({ page: this.page });
            this.clearCreate();
            if (this.continousCreation === false) {
              this.$router.push('/producttype');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>